<template>
    <div class="main">
        <c-panel title="VALORES FIXOS DA FOLHA" titleIcon="fas fa-thumbtack">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Escolha o servidor para definir os eventos que se repetem todo mês."
                description="O valor configurado aqui preenche a grade da aba Folha sempre que a competência ainda não tiver lançamento para aquele evento. O que for alterado no mês vale só naquele mês."></el-alert>

            <el-form label-position="top" class="u-mb-10">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Instituição">
                            <el-select v-model="filtro.instituicao_cod" filterable :clearable="!instituicaoTravada"
                                :disabled="instituicaoTravada" placeholder="Selecione a instituição"
                                :loading="loadingInstituicoes" @change="buscar" style="width: 100%;">
                                <el-option v-for="item in instituicoes" :key="item.codigo" :label="item.nome" :value="item.codigo"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Servidor">
                            <el-input v-model="filtro.busca" clearable placeholder="Pesquisar por nome ou nº de registro"
                                @keyup.enter.native="buscar"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-button @click="buscar" type="info" plain icon="el-icon-search" style="width: 100%; margin-top: 21px;">FILTRAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="avisoAcesso" type="warning" :closable="false" class="u-mb-15" :title="avisoAcesso"></el-alert>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 110px;">Nr. Registro</th>
                            <th>Nome</th>
                            <th class="hidden-mobile">Unidade</th>
                            <th class="hidden-mobile">Cargo</th>
                            <th style="width: 90px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.registro">
                            <td>{{ item.nr_registro || item.registro }}</td>
                            <td>
                                <a href="#" class="link-servidor" :title="'Valores fixos de ' + item.nome"
                                    @click.prevent="abrir(item)">{{ item.nome }}</a>
                            </td>
                            <td class="hidden-mobile">{{ item.instituicao_nome || '-' }}</td>
                            <td class="hidden-mobile">{{ item.cargo || '-' }}</td>
                            <td class="u-text-center acao">
                                <el-button @click="abrir(item)" title="Configurar valores fixos" type="primary"
                                    icon="el-icon-edit" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="5" class="u-text-center">
                                {{ pesquisou ? 'Nenhum servidor encontrado.' : 'Selecione uma instituição ou pesquise por um servidor.' }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList && paginate.qtdItens">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">{{ paginate.qtdItens }} servidor(es) encontrado(s).</div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > porPagina">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="getPagePagination" :page-size="porPagina" background
                                layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>

<script>
// Filtro próprio: quem configura valor fixo trabalha numa unidade por vez e não
// deve herdar o filtro da tela de lançamentos, que tem outro ritmo de uso.
const CHAVE_FILTRO = 'ed543672FolhaPontoValoresFixos'

export default {
    name: 'FolhaPontoValorFixoList',

    data: () => ({
        statusList: true,
        pesquisou: false,
        loadingInstituicoes: false,
        porPagina: 50,
        instituicoes: [],
        restrito: false,
        avisoAcesso: '',
        items: [],
        filtro: { instituicao_cod: '', busca: '' },
        paginate: { page: 1, qtdItens: 0 }
    }),

    computed: {
        instituicaoTravada () {
            return this.restrito && this.instituicoes.length <= 1
        }
    },

    mounted () {
        this.getConfig()
        this.getInstituicoes()
        this.restaurarFiltro()
    },

    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },

        restaurarFiltro () {
            const salvo = this.filtroGuardado()

            if (salvo) {
                this.filtro.instituicao_cod = salvo.instituicao_cod || ''
                this.filtro.busca = salvo.busca || ''
                this.paginate.page = Number(salvo.page) || 1
            }

            if (this.filtro.instituicao_cod || this.filtro.busca) this.load()
        },

        filtroGuardado () {
            try {
                return JSON.parse(sessionStorage.getItem(CHAVE_FILTRO))
            } catch (e) {
                return null
            }
        },

        guardarFiltro () {
            try {
                sessionStorage.setItem(CHAVE_FILTRO, JSON.stringify({
                    instituicao_cod: this.filtro.instituicao_cod,
                    busca: this.filtro.busca,
                    page: this.paginate.page
                }))
            } catch (e) {
                // Sessão sem storage disponível: a tela funciona, só não lembra.
            }
        },

        getConfig () {
            this.$axios.get(`${this.baseUrl()}/configuracao/telas`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    if (res.data && res.data.itens_por_pagina) this.porPagina = Number(res.data.itens_por_pagina)
                })
                .catch(() => {})
        },

        getInstituicoes () {
            this.loadingInstituicoes = true

            this.$axios.get(`${this.baseUrl()}/instituicoes`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    const d = res.data || {}

                    this.instituicoes = Array.isArray(d.instituicoes) ? d.instituicoes : []
                    this.restrito = !!d.restrito
                    this.avisoAcesso = d.mensagem || ''

                    if (this.restrito && this.instituicoes.length === 1) {
                        this.filtro.instituicao_cod = this.instituicoes[0].codigo
                    }

                    this.loadingInstituicoes = false

                    if (this.filtro.instituicao_cod) this.load()
                })
                .catch(e => { this.loadingInstituicoes = false; this.$store.commit('throwException', e) })
        },

        buscar () {
            this.paginate.page = 1
            this.load()
        },

        load () {
            this.guardarFiltro()

            if (!this.filtro.instituicao_cod && !this.filtro.busca) {
                this.items = []
                this.paginate.qtdItens = 0
                this.pesquisou = false
                return
            }

            this.statusList = false
            this.pesquisou = true

            const params = {
                instituicao_cod: this.filtro.instituicao_cod,
                busca: this.filtro.busca,
                page: this.paginate.page,
                por_pagina: this.porPagina
            }

            this.$axios.get(`${this.baseUrl()}/servidores`, Object.assign({ params }, this.$store.getters.getHeaderAuth))
                .then(res => {
                    this.items = res.data.data || []
                    this.paginate.qtdItens = res.data.total || 0
                    this.statusList = true
                })
                .catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },

        abrir (servidor) {
            this.$router.push(`/admin/folha-ponto/valor-fixo/${servidor.registro}`)
        },

        getPagePagination (page) {
            this.paginate.page = page
            this.load()
        }
    }
}
</script>

<style scoped>
.link-servidor {
    color: #000000;
    text-decoration: none;
    cursor: pointer;
}
.link-servidor:hover,
.link-servidor:focus {
    text-decoration: underline;
}
</style>
